/* eslint-disable */
import { FuseNavigationItem } from "@fuse/components/navigation";

let nav: FuseNavigationItem[] = [
    {
        id: "freemium",
        type: "group",
        icon: "heroicons_outline:home",
        title: "Campaigns",
        subtitle: "Campaign management and reports",
        forRole: "admin|editor",

        children: [
            {
                id: "campaign.list",
                title: "Campaign",
                type: "basic",
                icon: "heroicons_outline:computer-desktop",
                link: "/campaigns",
                forRole: "admin|editor",
            },
            {
                id: "Analytics",
                title: "Reports",
                type: "basic",
                icon: "heroicons_outline:chart-pie",
                link: "/analitycs",
                // Exact path so the child reports-v2 route doesn't light this item up too,
                // but query params ignored — the campaign list lands here with ?campaigns=.
                isActiveMatchOptions: {
                    paths: "exact",
                    queryParams: "ignored",
                    fragment: "ignored",
                    matrixParams: "ignored",
                },
                forRole: "admin|editor",
            },
            {
                id: "reports-v2",
                title: "Reports",
                type: "basic",
                icon: "heroicons_outline:chart-bar",
                link: "/analitycs/reports-v2",
                badge: {
                    title: "Beta",
                    classes: "nav-beta-chip",
                },
                forRole: "admin|editor",
            },
            {
                // `forRole` no nombra a super-admin a propósito: `*hasRole` lo añade siempre.
                id: "drive-to-store",
                title: "Drive to Store",
                type: "basic",
                icon: "heroicons_outline:building-storefront",
                link: "/drive-to-store",
                forRole: "admin|editor",
            },
        ],
    },
    {
        id: "geo-audience",
        type: "group",
        title: "GeoAudiences",
        subtitle: "GeoAudiences management",
        children: [
            {
                id: "geo-audiences.audiences",
                title: "Geo Audiences",
                type: "basic",
                icon: "heroicons_outline:user-group",
                link: "/geo-audience",
            },
            {
                id: "geolist",
                title: "GeoList",
                type: "basic",
                icon: "heroicons_outline:globe-alt",
                link: "/geolist",
                forRole: "admin|editor",
            },
            {
                id: "audiences",
                title: "Audiences",
                type: "basic",
                icon: "heroicons_outline:users",
                link: "/audiences",
                forRole: "admin|editor",
            },
            {
                id: "device-trips",
                title: "device_trips.title",
                type: "basic",
                icon: "heroicons_outline:map",
                link: "/device-trips",
                forRole: "admin|editor",
            },
        ],
    },
    {
        id: "resources",
        title: "Resources",
        subtitle: "Resources available for campaign management",
        type: "group",
        icon: "heroicons_outline:cog",
        forRole: "admin|editor",
        children: [
            {
                id: "creatives",
                title: "Creatives",
                type: "basic",
                icon: "mat_outline:perm_media",
                link: "/creatives",
                forRole: "admin|editor",
            },
            {
                id: "deals",
                title: "Deals",
                type: "basic",
                icon: "heroicons_outline:document-text",
                link: "/deals",
                forRole: "admin|editor",
            },
            {
                id: "campaign-tools.tracking-events",
                title: "Tracking Events",
                type: "basic",
                icon: "heroicons_outline:truck",
                link: "/tracking-events",
                forRole: "admin|editor",
            },
            {
                id: "campaign-tools.publishersList",
                title: "Publisher Lists",
                type: "basic",
                icon: "heroicons_outline:cog",
                link: "/publishersList",
                forRole: "admin|editor",
            },
            {
                id: "advertisers",
                title: "Advertisers",
                type: "basic",
                icon: "heroicons_outline:briefcase",
                link: "/advertisers",
                forRole: "admin|editor",
            },
            {
                id: "agencies",
                title: "Agencies",
                type: "basic",
                icon: "heroicons_outline:building-office",
                link: "/agencies",
                forRole: "admin|editor",
            },
        ],
    },

    {
        id: "administration",
        title: "Administration",
        subtitle: "Tools available for administration and management",
        type: "group",
        icon: "heroicons_outline:cog",
        forRole: "admin",
        children: [
            {
                id: "campaign-tools.organizations",
                title: "Organizations",
                type: "basic",
                icon: "heroicons_outline:building-office-2",
                link: "/organizations",
                forRole: "admin",
            },
            {
                id: "doc-ui",
                title: "Design System",
                type: "basic",
                icon: "heroicons_outline:squares-2x2",
                link: "/doc-system/doc-ui",
                forRole: "superadmin",
            },
        ],
    },

    // Standalone (not part of any group) so it stays visible to every authenticated
    // user regardless of role — it must not inherit the "administration" group's forRole.
    {
        id: "advanced-case-studies",
        title: "Advanced Case Studies",
        tooltip: "Advanced Case Studies",
        type: "basic",
        icon: "heroicons_outline:academic-cap",
        link: "https://geo-activate-insights-hub.replit.app/",
        externalLink: true,
        target: "_blank",
    },
];

/* if (isDevMode()) {
    nav = nav.concat([
        {
            id: "pages",
            title: "Pages",
            subtitle: "Custom made page designs",
            type: "group",
            icon: "heroicons_outline:document",
            children: [ */
/* {
                    id: "pages.authentication",
                    title: "Authentication",
                    type: "collapsable",
                    icon: "heroicons_outline:lock-closed",
                    children: [
                        {
                            id: "pages.authentication.sign-in",
                            title: "Sign in",
                            type: "collapsable",
                            children: [
                                {
                                    id: "pages.authentication.sign-in.classic",
                                    title: "Classic",
                                    type: "basic",
                                    link: "/pages/authentication/sign-in/classic",
                                },
                                {
                                    id: "pages.authentication.sign-in.modern",
                                    title: "Modern",
                                    type: "basic",
                                    link: "/pages/authentication/sign-in/modern",
                                },
                                {
                                    id: "pages.authentication.sign-in.modern-reversed",
                                    title: "Modern Reversed",
                                    type: "basic",
                                    link: "/pages/authentication/sign-in/modern-reversed",
                                },
                                {
                                    id: "pages.authentication.sign-in.split-screen",
                                    title: "Split Screen",
                                    type: "basic",
                                    link: "/pages/authentication/sign-in/split-screen",
                                },
                                {
                                    id: "pages.authentication.sign-in.split-screen-reversed",
                                    title: "Split Screen Reversed",
                                    type: "basic",
                                    link: "/pages/authentication/sign-in/split-screen-reversed",
                                },
                                {
                                    id: "pages.authentication.sign-in.fullscreen",
                                    title: "Fullscreen",
                                    type: "basic",
                                    link: "/pages/authentication/sign-in/fullscreen",
                                },
                                {
                                    id: "pages.authentication.sign-in.fullscreen-reversed",
                                    title: "Fullscreen Reversed",
                                    type: "basic",
                                    link: "/pages/authentication/sign-in/fullscreen-reversed",
                                },
                            ],
                        },
                        {
                            id: "pages.authentication.sign-up",
                            title: "Sign up",
                            type: "collapsable",
                            link: "/pages/authentication/sign-up",
                            children: [
                                {
                                    id: "pages.authentication.sign-up.classic",
                                    title: "Classic",
                                    type: "basic",
                                    link: "/pages/authentication/sign-up/classic",
                                },
                                {
                                    id: "pages.authentication.sign-up.modern",
                                    title: "Modern",
                                    type: "basic",
                                    link: "/pages/authentication/sign-up/modern",
                                },
                                {
                                    id: "pages.authentication.sign-up.modern-reversed",
                                    title: "Modern Reversed",
                                    type: "basic",
                                    link: "/pages/authentication/sign-up/modern-reversed",
                                },
                                {
                                    id: "pages.authentication.sign-up.split-screen",
                                    title: "Split Screen",
                                    type: "basic",
                                    link: "/pages/authentication/sign-up/split-screen",
                                },
                                {
                                    id: "pages.authentication.sign-up.split-screen-reversed",
                                    title: "Split Screen Reversed",
                                    type: "basic",
                                    link: "/pages/authentication/sign-up/split-screen-reversed",
                                },
                                {
                                    id: "pages.authentication.sign-up.fullscreen",
                                    title: "Fullscreen",
                                    type: "basic",
                                    link: "/pages/authentication/sign-up/fullscreen",
                                },
                                {
                                    id: "pages.authentication.sign-up.fullscreen-reversed",
                                    title: "Fullscreen Reversed",
                                    type: "basic",
                                    link: "/pages/authentication/sign-up/fullscreen-reversed",
                                },
                            ],
                        },
                        {
                            id: "pages.authentication.sign-out",
                            title: "Sign out",
                            type: "collapsable",
                            link: "/pages/authentication/sign-out",
                            children: [
                                {
                                    id: "pages.authentication.sign-out.classic",
                                    title: "Classic",
                                    type: "basic",
                                    link: "/pages/authentication/sign-out/classic",
                                },
                                {
                                    id: "pages.authentication.sign-out.modern",
                                    title: "Modern",
                                    type: "basic",
                                    link: "/pages/authentication/sign-out/modern",
                                },
                                {
                                    id: "pages.authentication.sign-out.modern-reversed",
                                    title: "Modern Reversed",
                                    type: "basic",
                                    link: "/pages/authentication/sign-out/modern-reversed",
                                },
                                {
                                    id: "pages.authentication.sign-out.split-screen",
                                    title: "Split Screen",
                                    type: "basic",
                                    link: "/pages/authentication/sign-out/split-screen",
                                },
                                {
                                    id: "pages.authentication.sign-out.split-screen-reversed",
                                    title: "Split Screen Reversed",
                                    type: "basic",
                                    link: "/pages/authentication/sign-out/split-screen-reversed",
                                },
                                {
                                    id: "pages.authentication.sign-out.fullscreen",
                                    title: "Fullscreen",
                                    type: "basic",
                                    link: "/pages/authentication/sign-out/fullscreen",
                                },
                                {
                                    id: "pages.authentication.sign-out.fullscreen-reversed",
                                    title: "Fullscreen Reversed",
                                    type: "basic",
                                    link: "/pages/authentication/sign-out/fullscreen-reversed",
                                },
                            ],
                        },
                        {
                            id: "pages.authentication.forgot-password",
                            title: "Forgot password",
                            type: "collapsable",
                            link: "/pages/authentication/forgot-password",
                            children: [
                                {
                                    id: "pages.authentication.forgot-password.classic",
                                    title: "Classic",
                                    type: "basic",
                                    link: "/pages/authentication/forgot-password/classic",
                                },
                                {
                                    id: "pages.authentication.forgot-password.modern",
                                    title: "Modern",
                                    type: "basic",
                                    link: "/pages/authentication/forgot-password/modern",
                                },
                                {
                                    id: "pages.authentication.forgot-password.modern-reversed",
                                    title: "Modern Reversed",
                                    type: "basic",
                                    link: "/pages/authentication/forgot-password/modern-reversed",
                                },
                                {
                                    id: "pages.authentication.forgot-password.split-screen",
                                    title: "Split Screen",
                                    type: "basic",
                                    link: "/pages/authentication/forgot-password/split-screen",
                                },
                                {
                                    id: "pages.authentication.forgot-password.split-screen-reversed",
                                    title: "Split Screen Reversed",
                                    type: "basic",
                                    link: "/pages/authentication/forgot-password/split-screen-reversed",
                                },
                                {
                                    id: "pages.authentication.forgot-password.fullscreen",
                                    title: "Fullscreen",
                                    type: "basic",
                                    link: "/pages/authentication/forgot-password/fullscreen",
                                },
                                {
                                    id: "pages.authentication.forgot-password.fullscreen-reversed",
                                    title: "Fullscreen Reversed",
                                    type: "basic",
                                    link: "/pages/authentication/forgot-password/fullscreen-reversed",
                                },
                            ],
                        },
                        {
                            id: "pages.authentication.reset-password",
                            title: "Reset password",
                            type: "collapsable",
                            link: "/pages/authentication/reset-password",
                            children: [
                                {
                                    id: "pages.authentication.reset-password.classic",
                                    title: "Classic",
                                    type: "basic",
                                    link: "/pages/authentication/reset-password/classic",
                                },
                                {
                                    id: "pages.authentication.reset-password.modern",
                                    title: "Modern",
                                    type: "basic",
                                    link: "/pages/authentication/reset-password/modern",
                                },
                                {
                                    id: "pages.authentication.reset-password.modern-reversed",
                                    title: "Modern Reversed",
                                    type: "basic",
                                    link: "/pages/authentication/reset-password/modern-reversed",
                                },
                                {
                                    id: "pages.authentication.reset-password.split-screen",
                                    title: "Split Screen",
                                    type: "basic",
                                    link: "/pages/authentication/reset-password/split-screen",
                                },
                                {
                                    id: "pages.authentication.reset-password.split-screen-reversed",
                                    title: "Split Screen Reversed",
                                    type: "basic",
                                    link: "/pages/authentication/reset-password/split-screen-reversed",
                                },
                                {
                                    id: "pages.authentication.reset-password.fullscreen",
                                    title: "Fullscreen",
                                    type: "basic",
                                    link: "/pages/authentication/reset-password/fullscreen",
                                },
                                {
                                    id: "pages.authentication.reset-password.fullscreen-reversed",
                                    title: "Fullscreen Reversed",
                                    type: "basic",
                                    link: "/pages/authentication/reset-password/fullscreen-reversed",
                                },
                            ],
                        },
                        {
                            id: "pages.authentication.unlock-session",
                            title: "Unlock session",
                            type: "collapsable",
                            link: "/pages/authentication/unlock-session",
                            children: [
                                {
                                    id: "pages.authentication.unlock-session.classic",
                                    title: "Classic",
                                    type: "basic",
                                    link: "/pages/authentication/unlock-session/classic",
                                },
                                {
                                    id: "pages.authentication.unlock-session.modern",
                                    title: "Modern",
                                    type: "basic",
                                    link: "/pages/authentication/unlock-session/modern",
                                },
                                {
                                    id: "pages.authentication.unlock-session.modern-reversed",
                                    title: "Modern Reversed",
                                    type: "basic",
                                    link: "/pages/authentication/unlock-session/modern-reversed",
                                },
                                {
                                    id: "pages.authentication.unlock-session.split-screen",
                                    title: "Split Screen",
                                    type: "basic",
                                    link: "/pages/authentication/unlock-session/split-screen",
                                },
                                {
                                    id: "pages.authentication.unlock-session.split-screen-reversed",
                                    title: "Split Screen Reversed",
                                    type: "basic",
                                    link: "/pages/authentication/unlock-session/split-screen-reversed",
                                },
                                {
                                    id: "pages.authentication.unlock-session.fullscreen",
                                    title: "Fullscreen",
                                    type: "basic",
                                    link: "/pages/authentication/unlock-session/fullscreen",
                                },
                                {
                                    id: "pages.authentication.unlock-session.fullscreen-reversed",
                                    title: "Fullscreen Reversed",
                                    type: "basic",
                                    link: "/pages/authentication/unlock-session/fullscreen-reversed",
                                },
                            ],
                        },
                        {
                            id: "pages.authentication.confirmation-required",
                            title: "Confirmation required",
                            type: "collapsable",
                            link: "/pages/authentication/confirmation-required",
                            children: [
                                {
                                    id: "pages.authentication.confirmation-required.classic",
                                    title: "Classic",
                                    type: "basic",
                                    link: "/pages/authentication/confirmation-required/classic",
                                },
                                {
                                    id: "pages.authentication.confirmation-required.modern",
                                    title: "Modern",
                                    type: "basic",
                                    link: "/pages/authentication/confirmation-required/modern",
                                },
                                {
                                    id: "pages.authentication.confirmation-required.modern-reversed",
                                    title: "Modern Reversed",
                                    type: "basic",
                                    link: "/pages/authentication/confirmation-required/modern-reversed",
                                },
                                {
                                    id: "pages.authentication.confirmation-required.split-screen",
                                    title: "Split Screen",
                                    type: "basic",
                                    link: "/pages/authentication/confirmation-required/split-screen",
                                },
                                {
                                    id: "pages.authentication.confirmation-required.split-screen-reversed",
                                    title: "Split Screen Reversed",
                                    type: "basic",
                                    link: "/pages/authentication/confirmation-required/split-screen-reversed",
                                },
                                {
                                    id: "pages.authentication.confirmation-required.fullscreen",
                                    title: "Fullscreen",
                                    type: "basic",
                                    link: "/pages/authentication/confirmation-required/fullscreen",
                                },
                                {
                                    id: "pages.authentication.confirmation-required.fullscreen-reversed",
                                    title: "Fullscreen Reversed",
                                    type: "basic",
                                    link: "/pages/authentication/confirmation-required/fullscreen-reversed",
                                },
                            ],
                        },
                    ],
                }, */
/*                 {
                    id: "pages.error",
                    title: "Error",
                    type: "collapsable",
                    icon: "heroicons_outline:exclamation-circle",
                    children: [
                        {
                            id: "pages.error.404",
                            title: "404",
                            type: "basic",
                            link: "/pages/error/404",
                        },
                        {
                            id: "pages.error.500",
                            title: "500",
                            type: "basic",
                            link: "/pages/error/500",
                        },
                    ],
                },
            ],
        },
    ]);
} */

export const defaultNavigation = nav;

export const compactNavigation: FuseNavigationItem[] = [
    {
        id: "dashboards",
        title: "Dashboards",
        tooltip: "Dashboards",
        type: "aside",
        icon: "heroicons_outline:home",
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: "apps",
        title: "Apps",
        tooltip: "Apps",
        type: "aside",
        icon: "heroicons_outline:qrcode",
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: "pages",
        title: "Pages",
        tooltip: "Pages",
        type: "aside",
        icon: "heroicons_outline:document-duplicate",
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: "user-interface",
        title: "UI",
        tooltip: "UI",
        type: "aside",
        icon: "heroicons_outline:rectangle-stack",
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: "navigation-features",
        title: "Navigation",
        tooltip: "Navigation",
        type: "aside",
        icon: "heroicons_outline:bars-3",
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: "dashboards",
        title: "DASHBOARDS",
        type: "group",
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: "apps",
        title: "APPS",
        type: "group",
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: "others",
        title: "OTHERS",
        type: "group",
    },
    {
        id: "pages",
        title: "Pages",
        type: "aside",
        icon: "heroicons_outline:document-duplicate",
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: "user-interface",
        title: "User Interface",
        type: "aside",
        icon: "heroicons_outline:rectangle-stack",
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: "navigation-features",
        title: "Navigation Features",
        type: "aside",
        icon: "heroicons_outline:bars-3",
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: "dashboards",
        title: "Dashboards",
        type: "group",
        icon: "heroicons_outline:home",
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: "apps",
        title: "Apps",
        type: "group",
        icon: "heroicons_outline:qrcode",
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: "pages",
        title: "Pages",
        type: "group",
        icon: "heroicons_outline:document-duplicate",
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: "user-interface",
        title: "UI",
        type: "group",
        icon: "heroicons_outline:rectangle-stack",
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: "navigation-features",
        title: "Misc",
        type: "group",
        icon: "heroicons_outline:bars-3",
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
];
